import LazyLoad from "vanilla-lazyload";
new LazyLoad()

import options from './shopifyOptions.js';
import alphabetScroll from './alphabetScroll.js'

import '@shopify/buy-button-js'

window.addEventListener('load', function() {
    // Shopify
    window.initShopify = function() {
        console.log("Shopify init")

        var client = ShopifyBuy.buildClient({
            domain: 'selftitled-shoerts.myshopify.com',
            storefrontAccessToken: process.env.TOKEN
        });
    
        var ui = ShopifyBuy.UI.init(client)
        
        // .then(function (ui) {
            $('.shopify-product').each(function(index, el) {
                // console.log(el)
                const id = $(el).attr('data-id')
    
                if (!id) return
    
                ui.createComponent('product', {
                    id: id,
                    node: el,
                    moneyFormat: '%E2%82%AC%7B%7Bamount_with_comma_separator%7D%7D',
                    options: options
                });
            })
        // });

        // $('.product-placeholder').removeClass('visible')

        window.shopifyInitialized = true
    }

    // if (Consent.shopify.consent) {
    //     initShopify()
    // } else {
    //     $('.product-placeholder').addClass('visible')

    //     $('button.shop-enable').on('click', function() {
    //         Consent.shopify.confirm()
    //     })
    // }

    initShopify()

    const alphabet = new alphabetScroll()
    alphabet.init()

    if ('Matomo' in window) window.MatomoTracker = Matomo.getTracker()


    // Mobile

    if (isMobile) {
        const mobileItems = document.querySelectorAll('.images figure, .info');//$('.images figure, .info')

        $(mobileItems).on('click', function(e) {
            const index = [...mobileItems].indexOf(this)
            window.jump(mobileItems[index+1], {
                duration: 500
            })
        });

        $('.info-wrapper').on('click', function(e) {
            e.stopPropagation()
        })
    }

    // $('.images').on('click', function(e) {
        // $(this).siblings('.product-title').addClass('hidden')
        // $(this).siblings('.info').addClass('show')
    // })

    // $('.info').on('click', function(e) {
    //     if ($(e.target).hasClass('info')) {
    //         $(this).removeClass('show')
    //         $(this).siblings('.product-title').removeClass('hidden')
    //     }
    // })
})